import { render, staticRenderFns } from "./submission-panel-tabs.vue?vue&type=template&id=2ba3dfae&scoped=true&"
import script from "./submission-panel-tabs.vue?vue&type=script&lang=ts&"
export * from "./submission-panel-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./submission-panel-tabs.vue?vue&type=style&index=0&id=2ba3dfae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba3dfae",
  null
  
)

export default component.exports